__webpack_require__.p = "/standard-plp/_next/";